import { Redirect } from 'react-router-dom';

import { SolaForceCookie, useCookie } from '~/hooks/useCookie';
import { LoadingView } from '~/scenes/PortalViews/components/LoadingView';
import { RedirectToPortalHomepage } from '~/scenes/PortalViews/components/RedirectToPortalHomepage';

export const RedirectToPortalContinue = () => {
  const { value: currentPageCookie } = useCookie(SolaForceCookie.CurrentPage);

  // Continue where user left off
  if (currentPageCookie) {
    // Redirect to UI2 view
    if (currentPageCookie.startsWith('/v2')) {
      return <Redirect to={currentPageCookie.substring(3)} />;
    }

    // Redirect to Legacy view
    window.location.replace('/');
    return <LoadingView />;
  }

  // Continue to homepage
  return <RedirectToPortalHomepage />;
};
